import { Icon, Link } from 'office-ui-fabric-react';
import React, { FunctionComponent, useCallback } from 'react';
import styled from 'styled-components';

import { SrOnlyText } from '../SrOnlyText/SrOnlyText';
import { BaseDetailCard } from '../BaseDetailCard/BaseDetailCard';
import { IPeopleDetailHeaderProps, PeopleDetailHeader } from '../PeopleDetailHeader/PeopleDetailHeader';
import { body1Font } from '../Typography/Typography';

export interface IPeopleDetailCardProps extends IPeopleDetailHeaderProps {
  profileLink?: string;
  onProfileClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  children?: React.ReactNode;
}

const StyledBaseDetailCard = styled(BaseDetailCard)`
  padding-bottom: 25px;
`;

const StyledIcon = styled(Icon)`
  font-size: 20px;
  margin-right: 10px;
  color: #0078d4;
`;

const StyledLinkText = styled.span``;

const StyledLink = styled(Link)`
  ${body1Font}
  margin: 25px 20px;
  display: inline-flex;
  align-items: flex-start;
  text-decoration: none !important;
  position: relative;
  left: -5px;
  padding: 5px;
  color: #323130;
  &:hover,
  &:focus {
    color: #0078d4;
    ${StyledLinkText} {
      text-decoration: underline !important;
    }
  }
`;

const Padding = styled.div`
  margin-top: 30px;
`;

export const PeopleDetailCard: FunctionComponent<IPeopleDetailCardProps> = props => {
  const { onProfileClick, profileLink, title } = props;

  const onClick = useCallback(
    (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      if (onProfileClick) {
        onProfileClick(event);
      }
    },
    [onProfileClick]
  );

  return (
    <StyledBaseDetailCard>
      <PeopleDetailHeader {...props} />
      {props.children}
      {profileLink ? (
        <StyledLink href={profileLink} target="_blank" onClick={onClick}>
          <StyledIcon iconName="contact" />
          <StyledLinkText>See full profile on LinkedIn </StyledLinkText>
          <SrOnlyText>{`Opens ${title}'s LinkedIn profile in a new window.`}</SrOnlyText>
        </StyledLink>
      ) : (
        <Padding />
      )}
    </StyledBaseDetailCard>
  );
};

export default PeopleDetailCard;
